import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ShareProvider } from './context/ShareContext'; // Aggiungi questa riga
import { TodoProvider } from './context/TodoContext';
import { CategoryProvider } from './context/CategoryContext';
import { ThemeProvider } from './context/ThemeContext';

import Navbar from './components/layout/Navbar';
import Landing from './components/pages/Landing';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import VerifyEmail from './components/auth/VerifyEmail';
import Dashboard from './components/pages/Dashboard';
import NotFound from './components/pages/NotFound';
import PrivateRoute from './components/routing/PrivateRoute';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
          <ShareProvider>
            <Router>
              <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-200">
                <Navbar />
                <div className="container mx-auto p-4 pt-8">
                  <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/verify-email/:token" element={<VerifyEmail />} />
                    <Route 
                      path="/dashboard" 
                      element={
                        <PrivateRoute>
                          <CategoryProvider>
                            <TodoProvider>
                              <Dashboard />
                            </TodoProvider>
                          </CategoryProvider>
                        </PrivateRoute>
                      }
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </div>
              </div>
            </Router>
        </ShareProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
